import * as React from "react";
import { useState } from "react";
import uuid from 'uuid/v4';
import { Logger } from "./Logger";
class Modal {
    constructor(id, handler, object) {
        this.close = () => {
            this._opened = false;
            this._handler.close(this._id);
        };
        this._handler = handler;
        this._id = id;
        this._opened = true;
        this._element = object.element;
        this._props = object.props;
    }
    get id() {
        return this._id;
    }
    get element() {
        return this._element;
    }
    get props() {
        const propsOnCancel = this._props.onCancel;
        return Object.assign(Object.assign({}, this._props), { visible: this._opened, onCancel: () => {
                propsOnCancel && propsOnCancel();
                this.close();
            } });
    }
}
class ModalHandler {
    constructor(updateModalsToRender) {
        this.open = (object) => {
            let id;
            let count = 0;
            do {
                id = uuid();
                count++;
            } while (this._modals[id] !== undefined && count < 100);
            this._modals[id] = new Modal(id, this, object);
            this._updateModalsToRender(Object.values(this._modals));
            return this._modals[id];
        };
        this.close = (id) => {
            delete this._modals[id];
            this._updateModalsToRender(Object.values(this._modals));
        };
        this._updateModalsToRender = updateModalsToRender;
        this._modals = {};
    }
}
let modalHandler;
const ModalElement = React.memo(() => {
    const [modalsToRender, setModalsToRender] = useState([]);
    if (!modalHandler) {
        modalHandler = new ModalHandler(setModalsToRender);
    }
    return (React.createElement("div", { className: "modal" }, modalsToRender.map((modal, index) => {
        const ModalElement = modal.element;
        return (React.createElement(ModalElement, Object.assign({ key: index, modalId: index }, modal.props)));
    })));
});
const open = (ModalElement, props = {}, options = {}) => {
    if (!modalHandler) {
        Logger.error(`A Modal was opened, but the ModalHandler was not initialized. Please add an element <ModalHandler> in your tree.`);
        return;
    }
    return modalHandler.open({
        element: ModalElement,
        props: props,
        options: options,
    });
};
export default ModalElement;
export { ModalElement, open, };
//# sourceMappingURL=ModalHandler.js.map